export default __webpack_public_path__ + "d2347e51fd97aa5b01119f9af4616266.png";